<template>
  <a
    class="card"
    :href="'https://www.murdoch.edu.au' + result.url_path.raw"
    data-event="site-interaction"
    :data-category="result.id.raw"
    data-type="link"
    :data-value="result.title.raw"
    @click="handleClick"
  >
    <p class="card-header">
      <small><strong>{{ result.study_level.raw.toUpperCase() }}</strong></small>
      <small :class="result.curriculum_item_type.raw.toLowerCase()"><strong>{{ result.curriculum_item_type.raw.toUpperCase() }}</strong></small>
    </p>
    <div class="card-body">
      <div class="card-title-link">
        <a
          class="h5"
          :href="'https://www.murdoch.edu.au' + result.url_path.raw"
        >
          {{ result.title.raw }}
        </a>
      </div>
      <p class="card-text">
        <small class="d-flex">
          <span class="result-code"><strong>Code:</strong>&nbsp;{{ result.curriculum_item_code.raw }}</span>
          <span v-if="result.selection_rank?.raw" class="selection-rank"><strong>Selection Rank:</strong>&nbsp;{{ result.selection_rank.raw }}</span>
        </small>
      </p>
      <p class="card-text">
        <small>{{ result.meta_description.raw }}</small>
      </p>
    </div>
  </a>
</template>

<script setup>
import { trackSearchClick } from '@elastic/behavioral-analytics-javascript-tracker';

const emit = defineEmits(['linkClicked'])

const { result, searchInputValue } = defineProps({
  result: {
    type: Object,
    required: true
  },
  searchInputValue: {
    type: String,
    required: true
  }
})

const handleClick = (event) => {
  // track click in elastic behavioral analytics
  trackSearchClick({
    // document that they clicked on
    document: { id: result.id.raw, index: result.curriculum_item_type.raw.toLowerCase() },
    page: {
      url: 'https://www.murdoch.edu.au' + result.url_path.raw
    },
    // the query and results that they used to find this document
    search: {
      query: searchInputValue,
      results: {
        items: [
          {
            document: {
              id: result.id.raw,
              index: result.curriculum_item_type.raw.toLowerCase(),
            },
            page: {
              url: 'https://www.murdoch.edu.au' + result.url_path.raw,
            },
          },
        ],
      },
      search_application: "course-finder"
    }
  });

  emit('linkClicked', event)
}
</script>